import { state } from '@angular/animations';
import { BranchDocument } from './branch-document'
import { City } from './city'
import { BranchRequest } from './branch-request'
import { User } from './user';

export class Branch {
  branchId: number;
  parentId: number;
  name: string;
  inviteCode: string;
  description: string;
  canInsertSubBranch: boolean;
  canInsertUser: boolean;
  applicationId: number;
  location: string;
  address: string;
  phoneNumber: string;
  children: Branch[];
  hasChildren: boolean;
  expanded: boolean = true;
  isDefaultBranch: boolean;
  branchDocument: BranchDocument[];
  city: City;
  branchDocumentTypeId: number;
  maxUserCount: number;
  maxSubBranch: number;
  parent: Branch;
  hasChild: boolean;
  doneProblemCount: number;
  problemCount: number;
  hasSubBranch: boolean;
  createDate: string;
  countSubBranch: number;
  countFamilyMember: number;
  countFamily: string;
  averageScore: number;
  provinceTitle: string;
  campaignMemberCount: number;
  isConfirmed: boolean;
  branchRequest: BranchRequest;
  mobileNumber: string;
  foundedDate: string;
  adminFirstName: string;
  adminLastName: string;
  useComputer: boolean;
  transferCapability: boolean;
  branchProfileImageUrl: string;
  users: User[];
  AdminGenderId: number;
  AdminNationalCode: string;

  constructor() {
    this.branchDocument = new Array<BranchDocument>();
    this.city = new City();
    this.branchRequest = new BranchRequest();
  }

}
